import { Col } from "react-bootstrap";
import React, { useState } from "react";

const ProjectCard = ({ title, description, imgUrl, link }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleClick = () => {
    window.open(link, "_blank");
  };

  const handleProjectTabHover = (e) => {
    const projectTab = e.currentTarget.querySelector(".proj-tab");
    if (projectTab) {
      projectTab.style.display = "block";
    }
  };

  const handleProjectTabLeave = (e) => {
    const projectTab = e.currentTarget.querySelector(".proj-tab");
    if (projectTab) {
      projectTab.style.display = "none";
    }
  };

  return (
    <Col xs={12} sm={6} md={4}>
      <div
        className="proj-imgbx"
        onMouseEnter={(e) => {
          handleMouseEnter();
          handleProjectTabHover(e);
        }}
        onMouseLeave={(e) => {
          handleMouseLeave();
          handleProjectTabLeave(e);
        }}
        onClick={handleClick}
        style={{ cursor: "pointer", position: "relative" }}
      >
        <img src={imgUrl} alt={title} />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
        <div
          className="proj-tab"
          style={{
            display: "none",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
          }}
        >
          <a href={link} target="_blank" rel="noopener noreferrer">
            
          </a>
        </div>
      </div>
    </Col>
  );
};

export default ProjectCard;
